import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile, updateProfile } from "../../shared/api/user";
import { Toast } from "../../components/Toast/Toast";

export default function ProfileForm() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await updateProfile(username, email);
    if (res.success) {
      setToastType("success");
      setToastMessage("Профиль обновлён");
      setTimeout(() => navigate("/profile"), 1000);
    } else {
      setToastType("error");
      setToastMessage(res.message || "Ошибка при обновлении профиля");
    }
  };

  useEffect(() => {
    getProfile()
      .then((data) => {
        setUser(data);
        setEmail(data.email);
        setUsername(data.username);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCloseToast = () => {
    setToastMessage("");
  };

  if (loading) {
    return <div className="p-6 text-center text-gray-500">Загрузка...</div>;
  }

  if (!user) {
    return (
      <div className="p-6 text-center text-red-500">
        Ошибка загрузки профиля
      </div>
    );
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="max-w-md mt-5 mx-auto p-4 bg-white rounded shadow"
      >
        <h2 className="text-xl font-semibold mb-4 text-center">Редактирование профиля</h2>

        <label className="block mb-2 text-[16px]">
          Имя пользователя:
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="mt-1 p-2 w-full border rounded-lg text-[16px]"
          />
        </label>

        <label className="block mb-4 text-[16px]">
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1 p-2 w-full border rounded-lg text-[16px]"
          />
        </label>

        <div className="flex gap-2">
          <button
            type="submit"
            className="bg-blue-600  text-white px-4 py-1 rounded-lg text-[16px] w-full hover:bg-blue-700"
          >
            Сохранить
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="border-blue-600 border-2 text-blue-600 px-4 py-1 rounded-lg text-[16px] w-full hover:bg-blue-700 hover:border-blue-700 hover:text-white"
          >
            Назад
          </button>
        </div>
      </form>

      <Toast message={toastMessage} type={toastType} onClose={handleCloseToast} />
    </>
  );
}
